import { render, staticRenderFns } from "./fullScreenOverlay.vue?vue&type=template&id=ffa3b382&scoped=true&"
import script from "./fullScreenOverlay.vue?vue&type=script&lang=js&"
export * from "./fullScreenOverlay.vue?vue&type=script&lang=js&"
import style0 from "./fullScreenOverlay.vue?vue&type=style&index=0&id=ffa3b382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa3b382",
  null
  
)

export default component.exports